import { render, staticRenderFns } from "./TUWEN003.vue?vue&type=template&id=6e619c56"
import script from "./TUWEN003.vue?vue&type=script&lang=js"
export * from "./TUWEN003.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports